import React from 'react';
import { Check, Minus } from 'lucide-react';

const SIZE_CLASS = {
  sm: 'h-4 w-4 rounded-[4px]',
  md: 'h-[18px] w-[18px] rounded-[5px]',
  lg: 'h-5 w-5 rounded-[6px]',
};

const ICON_SIZE = {
  sm: 10,
  md: 12,
  lg: 13,
};

/** Console TableCheckbox — square checkbox for column picker */
export default function QawaemTableCheckbox({
  checked,
  indeterminate = false,
  disabled = false,
  size = 'md',
  onChange,
  title,
  className = '',
}) {
  const active = checked || indeterminate;
  const iconSize = ICON_SIZE[size];

  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={indeterminate ? 'mixed' : checked}
      disabled={disabled}
      title={title}
      onMouseDown={(e) => {
        e.stopPropagation();
      }}
      onClick={(e) => {
        e.stopPropagation();
        if (!disabled) onChange?.();
      }}
      className={`inline-flex shrink-0 items-center justify-center border-2 transition-colors ${SIZE_CLASS[size]} ${
        active
          ? 'border-copper-600 bg-copper-600 shadow-sm shadow-copper-900/15'
          : 'border-[#6e9b6e]/45 bg-white/95 hover:border-copper-400/70 hover:bg-copper-50/50'
      } ${disabled ? 'opacity-45 cursor-not-allowed' : 'cursor-pointer'} ${className}`.trim()}
    >
      {indeterminate ? (
        <Minus size={iconSize} className="text-white" strokeWidth={3} />
      ) : checked ? (
        <Check size={iconSize} className="text-white" strokeWidth={3} />
      ) : null}
    </button>
  );
}
